/**
 * EM 实体类通用EditView mixin
 *   提供常用组件的注册，路由状态，默认modelName
 *   初始化方法
 *   以及routeHelper的混入
 *
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
import EmEntityEditForm from "@/components/em/EmEntity/EditForm";
import EmViewTitle from "@/components/em/EmViewTitle";
import EmButton from "@/components/em/EmButton";
import emRouteHelperMixin from "@/mixin/em/helper/route";

export default {
    mixins: [emRouteHelperMixin],
    components: {EmEntityEditForm, EmViewTitle, EmButton},
    computed: {
        /**
         * 路由状态
         * 先看路由里有没有pathType,再看vuex中的crudState，因为base中的addNew是不会带pathType参数的，但是会修改crudState
         * @returns {*}
         */
        $_emCommonEditMixin_pathType() {
            return this.$_emRouterHelperMixin_pathType ? this.$_emRouterHelperMixin_pathType :
                this.modelName && this.$store.state[this.modelName].crudState
                    ? this.$store.state[this.modelName].crudState : "new"
        },
        /**
         * 默认的modelName，因为mixin的合并规则可以允许覆写，这里就不采用$_命名规范了
         * @returns {default.computed.$_emRouterHelperMixin_entityName}
         */
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        }

    },
    methods: {
        $_emCommonEditMixin_init() {
            //如果是新增，就新建vuex的entity，并设置vuex的crudState为new
            if (this.$_emCommonEditMixin_pathType === "new") {
                this.$store.commit(this.modelName + "/setNewEntity", {});
                this.$store.commit(this.modelName + "/setCrudState", 'new');
            }
        }
    },
    mounted() {
        this.$_emCommonEditMixin_init()
    }
};